<ng-container *ngIf="csvExport$ | async"></ng-container>

<div class="h-full w-full" cslPerfectScrollbar>
  <table mat-table #table [dataSource]="panels" class="w-full">
    <ng-container matColumnDef="position">
      <th i18n mat-header-cell *matHeaderCellDef>Позиция</th>
      <td mat-cell *matCellDef="let row">
        {{ row.position }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th i18n mat-header-cell *matHeaderCellDef>Наименование</th>
      <td mat-cell *matCellDef="let row">
        {{ row.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="height">
      <th mat-header-cell *matHeaderCellDef>
        <div class="flex align-center gap-0.5">
          <div i18n>Длина</div>
          <mat-icon i18n-matTooltip matTooltip="Длина готовой детали в миллиметрах" class="icon-size-4">info</mat-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.height }}
      </td>
    </ng-container>

    <ng-container matColumnDef="width">
      <th mat-header-cell *matHeaderCellDef>
        <div class="flex align-center gap-0.5">
          <div i18n>Ширина</div>
          <mat-icon i18n-matTooltip matTooltip="Ширина готовой детали в миллиметрах" class="icon-size-4">info</mat-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.width }}
      </td>
    </ng-container>

    <ng-container matColumnDef="orientation">
      <th i18n mat-header-cell *matHeaderCellDef>Текстура задана</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon class="mt-2">{{ row.orientation ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th i18n mat-header-cell *matHeaderCellDef>Кол-во</th>
      <td mat-cell *matCellDef="let row">
        {{ row.count }}
      </td>
    </ng-container>

    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>
        <div class="flex justify-between items-center gap-4">
          <div i18n>Примечание</div>
          <div>
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon class="mat-24">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="custom-mat-menu-panel w-96">
              <button i18n mat-menu-item (click)="exportCsv()">Экспортировать в CSV</button>
            </mat-menu>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div [cslOverflowTooltip]="row.remark || ''" class="remark-wrapper">
          {{ row.remark || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="l1">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка сверху">L1</th>
      <td mat-cell *matCellDef="let row">
        <div class="edge-info" [cslOverflowTooltip]="row.l1?.sign || ''">
          {{ row.l1?.sign || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="l2">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка снизу">L2</th>
      <td mat-cell *matCellDef="let row">
        <div class="edge-info" [cslOverflowTooltip]="row.l2?.sign || ''">
          {{ row.l2?.sign || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="w1">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка слева">W1</th>
      <td mat-cell *matCellDef="let row">
        <div class="edge-info" [cslOverflowTooltip]="row.w1?.sign || ''">
          {{ row.w1?.sign || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="w2">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Облицовка справа">W2</th>
      <td mat-cell *matCellDef="let row">
        <div class="edge-info" [cslOverflowTooltip]="row.w2?.sign || ''">
          {{ row.w2?.sign || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="editedAngles">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие углов с обработкой">
        <mat-icon svgIcon="vector_rectangle"></mat-icon>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openOutlineEditorDialog(row.uuid, thisOutlineEditorTabsEnum.Angles)">
          <mat-icon aria-label="">
            {{ isAngleEditing(row.uuid) ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="slotCount">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Количество пазов на панели">
        <mat-icon svgIcon="slot"></mat-icon>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openOutlineEditorDialog(row.uuid, thisOutlineEditorTabsEnum.Slots)">
          <span class="text-bold">{{ getSlotCount(row.uuid) }}</span>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="fastenersExists">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие присадки">
        <mat-icon svgIcon="milling_cutter"></mat-icon>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openOutlineEditorDialog(row.uuid, thisOutlineEditorTabsEnum.Fasteners)">
          <mat-icon aria-label="">
            {{ isFastenersExists(row.uuid) ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="attachment">
      <th
        [ngStyle]="{ display: panelSetHasAttachments ? '' : 'none' }"
        mat-header-cell
        *matHeaderCellDef
        i18n-matTooltip
        matTooltip="Вложение"></th>
      <td [ngStyle]="{ display: panelSetHasAttachments ? '' : 'none' }" mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openOutlineEditorDialog(row.uuid)">
          <mat-icon *ngIf="row.attachmentName" [matTooltip]="row.attachmentName">attach_file</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="outlineEditor">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Редактор контура">
        <mat-icon svgIcon="square_edit_outline"></mat-icon>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="openOutlineEditorDialog(row.uuid)">
          <mat-icon aria-label="">rounded_corner</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="faceBandingExists">
      <th mat-header-cell *matHeaderCellDef i18n-matTooltip matTooltip="Наличие облицовки пласти">
        <mat-icon>clear_all</mat-icon>
      </th>
      <td mat-cell *matCellDef="let row">
        <button
          enterLikeTabIgnore
          mat-icon-button
          (click)="openOutlineEditorDialog(row.uuid, thisOutlineEditorTabsEnum.FaceBanding)">
          <mat-icon>
            {{ isFaceBandingExists(row.uuid) ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
  </table>
</div>
